import * as types from './types';
import {
  AdminToolBookStatementCourseList,//结算课程列表
  AdminToolChangeCourseStatementModel,//编辑课程
  AdminToolBookStatementCourseDeleteModel,//删除课程
  SchoolAdminToolBookStatementBookCatalog,//课程用书列表
  AdminToolBookStatementCourseCatalogDeleteModel,//删除课程用书
  AdminToolBookStatementCourseCatalogAddBookModel,//给课程添加教材
  AdminToolBookStatementCourseCatalogChangeBookModel,//更改使用教材
  AdminToolChangeBookStatementBookCatalogList,//选择课程用书列表
  AdminToolBookCourseStatementChooseModel,//课程选择班级
} from 'src/model/AdminModel';

export default{
  //结算课程列表
  actionAdminToolBookStatementCourseList({commit,state},query){
    if (state.toolBookStatementCourseList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_TOOL_BOOK_STATEMENT_COURSE_LIST, {
      state: 'loading'
    });
    return AdminToolBookStatementCourseList.getInstance().execute(query).then(function(response){
      commit(types.ACTION_TOOL_BOOK_STATEMENT_COURSE_LIST, {
        state: 'loadend',
        list: response.list,
        total: response.total
      });
      return response;
    }).catch(function(err){
      commit(types.ACTION_TOOL_BOOK_STATEMENT_COURSE_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    })
  },

  actionAdminToolChangeCourseStatementModel({commit},query){
    return AdminToolChangeCourseStatementModel.getInstance().execute(query)
  },
  actionAdminToolBookCourseStatementChooseModel({commit},query){
    return AdminToolBookCourseStatementChooseModel.getInstance().execute(query)
  },

  actionAdminToolBookStatementCourseDeleteModel({commit},query){
    return AdminToolBookStatementCourseDeleteModel.getInstance().execute(query)
  },
  //课程用书列表
  actionAdminToolBookStatementBookCatalogList({commit,state},query){
    if (state.toolBookStatementBookCatalogList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_TOOL_BOOK_STATEMENT_COURSE_CATALOG_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolBookStatementBookCatalog.getInstance().execute(query).then(function(response){
      commit(types.ACTION_TOOL_BOOK_STATEMENT_COURSE_CATALOG_LIST, {
        state: 'loadend',
        list: response.list,
        total: response.total
      });
      return response;
    }).catch(function(err){
      commit(types.ACTION_TOOL_BOOK_STATEMENT_COURSE_CATALOG_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    })
  },

  actionAdminToolBookStatementCourseCatalogDeleteModel({commit},query){
    return AdminToolBookStatementCourseCatalogDeleteModel.getInstance().execute(query)
  },

  actionAdminToolBookStatementCourseCatalogAddBookModel({commit},query){
    return AdminToolBookStatementCourseCatalogAddBookModel.getInstance().execute(query)
  },

  actionAdminToolBookStatementCourseCatalogChangeBookModel({commit},query){
    return AdminToolBookStatementCourseCatalogChangeBookModel.getInstance().execute(query)
  },

  actionAdminToolChangeBookStatementBookCatalogList({commit,state},query){
    if (state.toolChangeBookStatementBookCatalogList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_TOOL_CHANGE_BOOK_STATEMENT_COURSE_LIST, {
      state: 'loading'
    });
    return AdminToolChangeBookStatementBookCatalogList.getInstance().execute(query).then(function(response){
      commit(types.ACTION_TOOL_CHANGE_BOOK_STATEMENT_COURSE_LIST, {
        state: 'loadend',
        list: response.list,
        total: response.total,
        book_catalog_export_url: response.book_catalog_export_url
      });
      return response;
    }).catch(function(err){
      commit(types.ACTION_TOOL_CHANGE_BOOK_STATEMENT_COURSE_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    })
  },
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/courseManagement/actions.js